import AjaxLoad from '../lib/ajax-load';
import { checkAndLoadFiles } from '../js/helper';

class OverlayLoad {
    constructor (element, options) {
        this.$loadButton = element;
        this.url = this.$loadButton.getAttribute('data-url');
        this.addToCart = this.$loadButton.hasAttribute('data-add-to-cart');
        this.overviewUrl = window.location.href;
        this.backButton = this.$loadButton.getAttribute('data-back') || '';
        this.overlay = null;
        this.closeButton = null;
        this.wait = false;
        this.shouldChangeUrl = this.$loadButton.getAttribute('data-change-url') === 'true';

        const settings = {
            onSubmitted: null
        };

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$loadButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.wait === false) {
                this.wait = true;
                this.loadContent();
            }
        });
    }

    setCloseEvent () {
        this.overlay.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-overlay-close') !== null) {
                this.closeOverlay();
                this.pushOverviewUrl();
            }
        });
    }

    loadContent () {
        function IsJsonString (str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        let requestMethod = 'GET';
        if (this.url.indexOf('/bookmark/article/list?userLocale') !== -1) {
            requestMethod = 'POST';
        }

        if (this.addToCart) {
            // Load Shop Overlay (add to cart)
            const overlayContent = document.querySelector('[data-overlay-shop]').innerHTML;
            this.generateOverlay('shop');
            document.body.appendChild(this.overlay);
            document.querySelector('[data-overlay-target]').innerHTML += overlayContent;

            const wait = setInterval(() => {
                this.overlay.classList.add('is--visible');
                document.body.classList.add('has--overlay');
                clearInterval(wait);
                this.wait = false;
            }, 100);

            this.setCloseEvent();
            this.setEvents();
        } else {
            // Load Default Overlay
            const ajaxLoad = new AjaxLoad(this.url, {
                requestMethod: requestMethod, // eslint-disable-line
                onSuccess: (resultText) => {
                    this.generateOverlay();
                    document.body.appendChild(this.overlay);

                    if (IsJsonString(resultText)) {
                        resultText = JSON.parse(resultText).html;
                    }

                    const $content = this.createElementFromHTML(resultText);
                    this.overlay.querySelector('[data-overlay-target]').appendChild($content);
                    checkAndLoadFiles($content);

                    const contentUpdateEvent = new CustomEvent('content.loaded', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: $content
                        }
                    });

                    window.dispatchEvent(contentUpdateEvent);

                    const wait = setInterval(() => {
                        if (this.overlay.querySelector('.ajax-content')) {
                            this.overlay.classList.add('is--visible');
                            document.body.classList.add('has--overlay');
                            clearInterval(wait);
                            this.wait = false;
                        } else {
                            console.log('waiting');
                        }
                    }, 100);

                    this.setCloseEvent();
                    this.pushOverlayUrl();

                    if (typeof this.settings.onSubmitted === 'function') {
                        this.settings.onSubmitted(this.overlay);
                    }
                }
            });
            ajaxLoad.initialize();
        }
    }

    createElementFromHTML (htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        if (div.children.length > 1) {
            const itemsArray = [];
            Array.prototype.push.apply(itemsArray, div.children);
            return itemsArray;
        } else {
            return div.firstChild;
        }
    }

    generateOverlay (overlay) {
        let template;
        this.overlay = document.createElement('section');
        this.overlay.classList.add('site-overlay');
        this.overlay.setAttribute('data-overlay', 'root');

        if (overlay !== undefined && overlay === 'shop') {
            template = '<div class="site-overlay__container is--shop"><div class="grid-container">';
            template += '<div class="site-overlay__inner" data-overlay-target>';
            template += '</div></div></div>';
        } else {
            template = '<div class="site-overlay__container"><div class="grid-container">';
            template += '<div class="site-overlay__inner" data-overlay-target>';
            template += '</div></div>';

            if (this.backButton !== null) {
                template += '<span class="site-overlay__back textlink textlink--arrow-left icon-arrow_left" data-overlay-close>' + this.backButton + '</span>';
            }

            template += '<span class="site-overlay__close icon-close" data-overlay-close></span></div>';
        }

        this.overlay.innerHTML = template;
    }

    closeOverlay () {
        this.overlay.classList.remove('is--visible');
        document.body.classList.remove('has--overlay');
        setTimeout(() => {
            const $overlay = document.querySelector('[data-overlay="root"]');
            $overlay.remove();
            this.overlay = null;
        }, 1250);
    }

    pushOverlayUrl () {
        if (this.shouldChangeUrl) {
            const state = { page: 'detail' };
            const title = '';
            const url = this.url;

            history.replaceState(state, title, url);
        }
    }

    pushOverviewUrl () {
        if (this.shouldChangeUrl) {
            const state = { page: 'overview' };
            const title = '';
            const url = this.overviewUrl;

            history.replaceState(state, title, url);
        }
    }
}

export { OverlayLoad };
